import { styled } from 'styletron-react';

export const Container = styled('div', {
  marginTop: '24px',
});
